import { useRouteError } from 'react-router-dom'
import { UncaughtErrorPage } from './uncaught-error-page'

export function RouterErrorWrapper() {
  const error = useRouteError() as Error
  
  return <UncaughtErrorPage error={error} />
}
